export default __webpack_public_path__ + "static/media/black@2x.0d81083f.png";